<template>
<div class="chapter">
<div class="inner_page">
<h2 id="toc">Story-Shaped Worship</h2>
<p class="h3">Following Patterns from the Bible and History</p>
<p class="center"><img alt="" src="Images/8429_TP.jpg"/></p>
<p class="h3">Robbie Fox Castleman</p>
<p class="firstcenter"><img alt="IVP Books Imprint" src="Images/IVP_Academic_Quarter.jpg"/></p>
<p class="firstcenter"><a href="http://www.IVPress.com/books" target="_blank">www.IVPress.com/books</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?0ed1e48c